export default __webpack_public_path__ + "static/media/card.cb2c847d.svg";